import React from "react";
import { Tool } from "../../../../stores/CommunityStore/tools/types";

interface ToolsProps {
  onShowPosts: () => void;
  topicName?: string;
  tools: Tool[];
  loading: boolean;
}

const ExternalArrow = () => (
  <svg viewBox="0 0 12 12" aria-hidden="true">
    <path
      d="M3 9 L9 3 M5 3 H9 V7"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Tools = ({ onShowPosts, topicName, tools, loading }: ToolsProps) => (
  <div className="view-tools">
    <div className="tools-header">
      <div className="tools-header-icon" aria-hidden="true">
        <span className="ic" aria-hidden="true">
          <svg viewBox="0 0 32 32">
            <use href="#ic-sparkle"></use>
          </svg>
        </span>
      </div>
      <div className="tools-header-text">
        <h2>
          Smart tools, <em>built to help you apply what we teach.</em>
        </h2>
        <p>
          Practical AI helpers for briefs, behavioural angles, problem framing,
          and the rest. Made by 42courses, free for members.
        </p>
      </div>
      <button type="button" className="tools-back-btn" onClick={onShowPosts}>
        <svg viewBox="0 0 12 12" aria-hidden="true">
          <path
            d="M7.5 2 L3 6 L7.5 10"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Back to posts
      </button>
    </div>

    <div className="tools-list">
      {loading && <div className="ui active centered inline loader" />}
      {!loading && tools.length === 0 && (
        <div className="community-shell__empty-state">
          <div className="community-shell__empty-state-icon" aria-hidden="true">
            <span className="ic" aria-hidden="true">
              <svg viewBox="0 0 32 32">
                <use href="#ic-sparkle"></use>
              </svg>
            </span>
          </div>
          <h3>Tools are not available yet</h3>
          <p>New tools will appear here as soon as they are ready.</p>
        </div>
      )}
      {!loading &&
        tools.map((tool) => (
          <article className="tool-card" key={tool.id}>
            <div className="tool-thumb">
              <img
                className="tool-thumb-img"
                src={tool.image_url}
                alt={tool.name}
              />
            </div>
            <div className="tool-content">
              <div className="tool-head">
                <h3 className="tool-title">{tool.name}</h3>
              </div>
              <p className="tool-desc">{tool.description}</p>
            </div>
            <a
              className="tool-cta"
              href={tool.target_url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open ${tool.name} in a new tab`}
            >
              Open tool
              <ExternalArrow />
            </a>
          </article>
        ))}
    </div>

    <div className="tools-footnote">
      <div className="tools-footnote-text">
        <strong>Spotted a tool we should build?</strong>
        <br />
        Tell us in{" "}
        <button type="button" onClick={onShowPosts}>
          #{topicName || "the community"}
        </button>
        . Most of the ones here started as a member's "wouldn't it be great
        if...".
      </div>
      <button
        type="button"
        className="tools-footnote-cta"
        onClick={onShowPosts}
      >
        Suggest a tool
        <svg viewBox="0 0 12 12" aria-hidden="true" width="12" height="12">
          <path
            d="M3 6 H9 M6 3 L9 6 L6 9"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
);

export default Tools;
